var _style, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 540",
    style: {
      enableBackground: "new 0 0 960 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34495E;}\n\t.st1{fill:#354E6C;}\n\t.st2{fill:#425688;}\n\t.st3{fill:#5E5BA0;}\n\t.st4{fill:#855BB1;}\n\t.st5{fill:#9B59B6;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    className: "st0",
    width: 960,
    height: 540
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WavesTop",
    transform: "translate(960, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TWave5",
    className: "st1",
    d: "M0,405c-30.3-2.6-60.7-5.2-89.5-13.1c-28.7-7.8-55.9-20.9-82.3-35.1c-26.4-14.3-52-29.7-71.4-51.9 c-19.3-22.2-32.5-51.2-40.6-78.6c-8.1-27.3-11.2-52.9-32.4-74c-21.3-21.1-60.8-37.6-78.6-62.2c-17.9-24.6-14-57.3-10.2-90.1H0V405z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "TWave4",
    className: "st2",
    d: "M0,324c-24.3-2.1-48.5-4.2-71.6-10.5c-23-6.2-44.7-16.7-65.9-28.1c-21.1-11.4-41.5-23.7-57-41.5 c-15.5-17.7-26.1-41-32.5-62.8c-6.5-21.9-9-42.4-26-59.3c-17-16.8-48.6-30-62.9-49.7C-330.1,52.4-327.1,26.2-324,0H0V324z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TWave3",
    className: "st3",
    d: "M0,243c-18.2-1.6-36.4-3.1-53.7-7.8c-17.2-4.8-33.6-12.6-49.4-21.1c-15.8-8.6-31.2-17.8-42.8-31.2 c-11.6-13.3-19.5-30.7-24.4-47.1c-4.8-16.4-6.7-31.8-19.4-44.4c-12.8-12.7-36.5-22.6-47.2-37.3c-10.7-14.8-8.4-34.4-6.1-54.1H0V243 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TWave2",
    className: "st4",
    d: "M0,162c-12.1-1-24.3-2.1-35.8-5.2c-11.5-3.2-22.4-8.4-32.9-14.1c-10.6-5.7-20.8-11.8-28.6-20.7 c-7.7-8.9-13-20.5-16.2-31.5c-3.3-10.9-4.5-21.2-13-29.6s-24.3-15-31.4-24.9c-7.2-9.8-5.6-22.9-4.1-36H0V162z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TWave1",
    className: "st5",
    d: "M0,81c-6.1-0.5-12.1-1-17.9-2.6c-5.7-1.6-11.2-4.2-16.5-7c-5.2-2.9-10.4-6-14.2-10.4 c-3.9-4.5-6.5-10.3-8.2-15.7c-1.6-5.5-2.2-10.6-6.4-14.8C-67.5,26.2-75.4,22.9-79,18c-3.5-4.9-2.8-11.4-2-18H0V81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "WavesBottom",
    transform: "translate(0, 540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BWave5",
    className: "st1",
    d: "M0-405c27.9,15.1,55.7,30.2,83.4,39.4c27.8,9.2,55.3,12.5,83.6,18.7c28.4,6.2,57.5,15.4,85.5,30.3 c28,14.8,54.8,35.5,63.4,64.7c8.5,29.3-1.1,67.1,11.2,94.4c12.2,27.3,46.2,44,62.9,68.5c16.6,24.5,15.8,56.7,15,89H0V-405z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BWave4",
    className: "st2",
    d: "M0-324c22.3,12.1,44.6,24.2,66.8,31.5c22.1,7.4,44.2,10,66.8,15c22.7,5,46,12.3,68.4,24.2 s43.8,28.4,50.7,51.8c6.9,23.4-0.8,53.7,8.9,75.5c9.8,21.8,37.1,35.2,50.4,54.8S324.6-25.8,324,0H0V-324z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BWave3",
    className: "st3",
    d: "M0-243c16.7,9.1,33.4,18.1,50.1,23.6c16.6,5.6,33.1,7.5,50.1,11.3c17,3.7,34.5,9.2,51.3,18.1 s32.9,21.3,38,38.9c5.2,17.5-0.6,40.2,6.7,56.6c7.4,16.4,27.8,26.4,37.8,41.1s9.5,34,9,53.4H0V-243z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BWave2",
    className: "st4",
    d: "M0-162c11.1,6,22.3,12.1,33.4,15.8c11.1,3.6,22.1,5,33.4,7.5c11.4,2.4,23,6.1,34.2,12 c11.2,6,21.9,14.2,25.3,25.9c3.5,11.7-0.4,26.9,4.5,37.8c4.9,10.9,18.5,17.6,25.2,27.4c6.6,9.8,6.3,22.7,6,35.6H0V-162z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BWave1",
    className: "st5",
    d: "M0-81c5.6,3,11.1,6,16.7,7.9c5.5,1.8,11,2.5,16.7,3.7c5.7,1.3,11.5,3.1,17.1,6.1 c5.6,2.9,11,7.1,12.7,12.9c1.7,5.9-0.2,13.4,2.2,18.9c2.5,5.5,9.3,8.8,12.6,13.7S81.2-6.5,81,0H0V-81z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.95765ba138ece6872dec4d7504836a25.svg";
export { ForwardRef as ReactComponent };